module.exports = __webpack_public_path__ + "static/media/ruzhishengmingshu.ac9b4663.png";